var map = {
	"./brands.json": [
		968,
		751
	],
	"./custom-icons.json": [
		969,
		752
	],
	"./full-color.json": [
		970,
		753
	],
	"./light.json": [
		971,
		754
	],
	"./solid.json": [
		972,
		755
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 956;
module.exports = webpackAsyncContext;